import React from 'react'
import useHeaderConfig from '../../../hooks/useHeaderConfig'

const TaxiCompanyList: React.FC = () => {
  useHeaderConfig({ title: '電話で予約' })
  return <>TODO</>
}

export default TaxiCompanyList
